import * as SVGICONS from "./Svgs";
export { SVGICONS };
